import React from 'react';
import { Box, Button } from '@indeed/ifl-components';
import LinkButton from 'Components/LinkButton/LinkButton';
import { IS_LOGGED_IN } from 'Utils/PassportUtil';
import { LegalDisclaimer } from 'Views/HomePage/LegalDisclaimer';
import PassportLinks from './_PassportLinks';
import './StartPageLinks.scss';
const HOME_PAGE = '/home';
const StartPageLinks = ({ onClickStart }) => {
    const isPassportLinksShown = !IS_LOGGED_IN;
    return (React.createElement("div", { className: "StartPageLinks" },
        isPassportLinksShown && React.createElement(PassportLinks, { nextPath: "/home" }),
        React.createElement(Box, { sx: {
                color: 'foreground',
                fontSize: 1,
                lineHeight: 'normal',
                margin: '1.25rem 0'
            } },
            React.createElement(LegalDisclaimer, null)),
        !isPassportLinksShown && (React.createElement(LinkButton, { to: HOME_PAGE, onClick: onClickStart },
            React.createElement(Button, { full: true, type: "button", className: "Landing-button", variant: "primary", size: "md" }, "\u540C\u610F\u3057\u3066\u59CB\u3081\u308B")))));
};
export default StartPageLinks;
